<template>
    <div class="toolbox-header">
        <button class="btn-icon icon-close" @click="closeToolbox" :disabled="loading"></button>
        <button class="btn-icon icon-center" @click="centerObject"></button>
        <button class="btn-icon icon-trash" @click="deleteObject" v-if="canDelete" :disabled="loading"></button>
        <h2>Aktives Objekt</h2>
        <div class="subheader">
            <div class="entry" v-show="getId">
                <div class="label">ID</div>
                <div class="desc">{{ getId }}</div>
            </div>
            <div class="entry" v-show="getLayerName">
                <div class="label">Layer</div>
                <div class="desc">{{ getLayerName }}</div>
            </div>
        </div>
        <div class="immo">
            <span class="note-chip" v-if="item.isPublishedToImmoscout">Veröffentlicht</span>
            <span class="note-chip" v-if="item.wasPublishedToImmoscout">War Veröffentlicht</span>
            <button class="btn-icon icon-immo" @click="openImmoscout" v-if="item.isPublishedToImmoscout"></button>
        </div>
    </div>
</template>

<script>
  import GeoObjectApi from '@/api/geoObject'

  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeToolbox () {
        this.$emit('close')
      },
      async deleteObject () {
        if (typeof this.item.delete === 'function') {
          this.$emit('loading', true)
          let result = await this.$dialog.delete({
            title: 'Objekt löschen',
            message: `Sind Sie sicher, dass Sie <strong>${this.item.getIdentifier()}</strong> löschen möchten?`,
            onConfirm: (dialog) => this.item.delete(),
            onConfirmError: (dialog, responseError) => {
              this.$alert.error(responseError.response.data.error)
            }
          })
          if (result && result.confirmed) {
            this.closeToolbox()
          }
          this.$emit('loading', false)
        }
      },
      async centerObject () {
        // switch mode to map
        if (this.$store.getters['geoview/getMapMode'] !== 'map') {
          this.$store.dispatch('geoview/setMapMode', 'map')
        }
        let response = await GeoObjectApi.getCoords(this.item.id)
        this.$store.dispatch('geoview/setCenter', response.coordinates)
      },
      openImmoscout () {
        window.open(this.item.immoscout_url)
      }
    },
    computed: {
      getId () {
        if (typeof this.item.getIdentifier === 'function') {
          return this.item.getIdentifier()
        }

        return this.item.id
      },
      getLayerName () {
        if (!this.item.loaded) {
          return false
        }
        if (typeof this.item.getLayer !== 'function') {
          return false
        }

        return this.item.getLayer() ? this.item.getLayer().title : false
      },
      canDelete () {
        if (!this.item.loaded) {
          return false
        }
        if (this.item.readonly) {
          return false
        }
        if (typeof this.item.getLayer !== 'function') {
          return false
        }
        return this.item.getLayer() ? this.item.getLayer().objectsAdoptable : false
      }
    }
  }
</script>

<style scoped>

</style>
